import React from 'react';

const renderPrice = (price) => {
  if (typeof price === 'string' && price.indexOf('$') === 0 && price.indexOf('/') === -1) {
    return (
      <span className="font-bebas" style={{ fontSize: '28px', color: '#C9A84C', lineHeight: 1 }}>
        <span className="font-body" style={{ fontSize: '14px', verticalAlign: 'super', marginRight: '1px' }}>$</span>
        {price.slice(1)}
      </span>
    );
  }
  return (
    <span className="font-bebas" style={{ fontSize: '22px', color: '#C9A84C', lineHeight: 1, letterSpacing: '0.5px' }}>
      {price}
    </span>
  );
};

export const MenuItemCard = ({ item, loc }) => (
  <div
    className="group h-full"
    style={{ background: '#1C1C1C', border: '1px solid rgba(201,168,76,0.10)', transition: 'transform 0.3s ease' }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-4px)')}
    onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
    data-testid={`menu-item-${item.id}`}
  >
    {/* Image */}
    <div className="relative overflow-hidden" style={{ height: '240px', background: '#1C1C1C' }}>
      {item.image ? (
        <img
          src={item.image}
          alt={loc(item.name)}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105"
          style={{ filter: 'brightness(0.6)' }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.75)')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(0.6)')}
        />
      ) : (
        <div className="w-full h-full" style={{ background: '#1C1C1C' }} data-testid="menu-item-image-placeholder" />
      )}
      <span
        className="font-bebas uppercase absolute"
        style={{ top: 0, left: 0, background: '#C9A84C', color: '#0A0A0A', fontSize: '9px', letterSpacing: '2px', padding: '5px 10px' }}
      >
        {loc(item.tag || item.category)}
      </span>
      {item.vegan && (
        <span
          className="font-bebas uppercase absolute"
          style={{ top: 0, right: 0, background: '#3E7D3A', color: '#F5F5F0', fontSize: '9px', letterSpacing: '2px', padding: '5px 10px' }}
          data-testid="vegan-badge"
        >
          Vegano
        </span>
      )}
    </div>

    {/* Content */}
    <div className="p-6">
      <h3 className="font-display" style={{ fontSize: '20px', fontWeight: 700, color: '#F5F5F0' }}>
        {loc(item.name)}
      </h3>
      {loc(item.description) ? (
        <p className="font-body mt-2" style={{ fontSize: '13px', fontWeight: 300, color: '#C2C1B6', lineHeight: 1.7 }}>
          {loc(item.description)}
        </p>
      ) : null}

      {item.price ? (
        <div className="flex justify-end items-center mt-5 pt-4" style={{ borderTop: '1px solid rgba(201,168,76,0.18)' }}>
          {renderPrice(item.price)}
        </div>
      ) : null}
    </div>
  </div>
);
